import Service from "../../Classes/Service";
import { serviceViewerSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    currentService: new Service(),
    addModal: false,
    editModal: false
}

export default function serviceViewerSlice(state = initialState, action) {
    switch (action.type) {
        case serviceViewerSliceDispatch.setCurrentService: {
            return {
                ...state,
                currentService: action.payload
            }
        }
        case serviceViewerSliceDispatch.setAddModal: {
            return {
                ...state,
                addModal: action.payload
            }
        }
        case serviceViewerSliceDispatch.setEditModal: {
            return {
                ...state,
                editModal: action.payload
            }
        }
        default:
            return state
    }
}
